export default "__VITE_ASSET__BVffXLCB__"